import { render, staticRenderFns } from "./deleteChart.vue?vue&type=template&id=34b28881"
import script from "./deleteChart.vue?vue&type=script&lang=js"
export * from "./deleteChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports